module.exports = __webpack_public_path__ + "static/media/Saddle_logomark_blue.955804e8.png";